<template>
  <v-sheet
    class="template-home"
    dark>
    <v-row>
      <v-col
        lg="3"
        md="4"
        sm="12"
        align-self="center">
        <v-img
          :src="whale2png"
          class="mx-auto"
          width="240"
          height="auto"
          contain />
      </v-col>
      <v-col
        lg="9"
        md="8"
        sm="12"
        align-self="center">
        <div class="template-home__content">
          <div class="template-home__title mb-4">
            เริ่มสร้างเทมเพลตของคุณ
          </div>
          <div class="template-home__subtitle mb-4">
            สร้างเทมเพลตไม่ยากเพิ่มความโดดเด่นให้กับคุณ
          </div>
          <create-button>
            <template #activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                class="template-home__btn"
                outlined
                x-large
                v-on="on">
                <v-icon
                  size="24"
                  left>
                  mdi-home
                </v-icon>
                เริ่มสร้าง
              </v-btn>
            </template>
          </create-button>
        </div>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import whale2png from '@/assets/img/2whale.png'
import CreateButton from './CreateButton.vue'

export default {
  components: { CreateButton },
  data () {
    return {
      whale2png,
      shipnityUrl: process.env.VUE_APP_SHIPNITY
    }
  }
}
</script>

<style scoped>
  .template-home {
    background: linear-gradient(270deg, #1BA7E1 17.87%, #14B7FB 100%);
    padding: 32px;
    border-radius: 12px;
  }
  .template-home__content {
    padding: 38px 12px;
  }
  .template-home__title {
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
  }
  .template-home__subtitle {
    font-weight: normal;
    font-size: 18px;
    line-height: 27px;
  }
  .template-home__btn {
    border-radius: 14px;
  }
</style>
